import {useQuery} from '@tanstack/react-query';

import {ICategory} from 'coreStore/data/categories/types';

import {getCategoriesQueryKey} from 'coreUtils/categories';

/**
 * `true` once the category tree of the language (its `root` entry) is in the React Query cache.
 * Subscribed, not read from the cache during render: the component re-renders when it gets loaded
 * (and the React Compiler does not memoize a stale value).
 *
 * @param {string} languageCode - Language of the tree
 * @returns {boolean} - Whether the tree is loaded
 */
const useIsCategoryTreeLoaded = (languageCode: string): boolean => {
	const {data = false} = useQuery<Record<string, ICategory>, Error, boolean>({
		queryKey: getCategoriesQueryKey(languageCode),
		queryFn: () => ({} as Record<string, ICategory>),
		enabled: false,
		staleTime: Infinity,
		select: (categories) => !!categories?.root,
	});

	return data;
};

export default useIsCategoryTreeLoaded;
